/**
 *
 * Status
 *
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from '@reduxjs/toolkit';
import { useLocation } from 'react-router-dom';
import { translate as t } from '../../utils/translator';
import Button from '../Button';
import Loader from '../Loader';
import KycSuccess from '../KycSuccess';
import Notify from '../Notify';
import { statusConstants } from './constants';

import { redirectKyc } from '../../containers/EkycPage/actions';
import { getUrlParam } from '../../helpers/route';

function Status(props) {
  const location = useLocation();
  const status = getUrlParam('status', null);
  const redirectKyc = errorCode => {
    props.redirectKyc(errorCode);
  };

  if (location.pathname === '/status' && status) {
    return (
      <div className="routeContainer notifyContainer">
        <Notify
          notifyType={status === '1' ? 'success' : 'error'}
          notifyheading={status === '1' ? 'Thank you!' : 'Something went wrong'}
          notifyDescription={
            status === '1'
              ? 'Your KYC verification is in progress, and it is expected to get complete soon.'
              : statusConstants.genericErrorMsg
          }
          buttonText="Close window"
          buttonClass="redirect"
          buttonOnClick={() => window.open('about:blank', '_self').close()}
        />
      </div>
    );
  }

  if (props.app.tokenExpiry && !props.app.linkError)
    redirectKyc('ERROR_SESSION_EXPIRED');

  if (props.app.loading || props.ekyc.loading || props.app.authLoading)
    return (
      <div className="routeContainer loaderContainer">
        <Loader
          loadingText={props.ekyc.loadingText || null}
          message={t('kyc14', props.language)}
        />
      </div>
    );

  if (
    props.ekyc.serverError ||
    props.app.serverError ||
    props.app.linkError
  ) {
    if (props.app.linkError)
      return (
        <div className="routeContainer notifyContainer">
          <Notify
            header={statusConstants.header}
            notifyType="error"
            notifyheading="Something went wrong"
            notifyDescription={statusConstants.genericErrorMsg}
            notifyCode="Error code: ERROR_INVALID_LINK"
            buttonText="Close window"
            buttonClass="redirect"
            buttonOnClick={() => window.open('about:blank', '_self').close()}
          />
        </div>
      );
    if (props.app.serverError) redirectKyc('UNKNOWN_ERROR');
    if (props.ekyc.serverError) redirectKyc('ERROR_EKYC_INTERNAL_TECHNICAL_ISSUE');
  }

  return null;
}

Status.propTypes = {};

const mapStateToProps = state => ({
  app: state.app,
  ekyc: state.ekyc,
  theme: state.app.theme,
  language: state.language.language
});

function mapDispatchToProps(dispatch) {
  return {
    redirectKyc: errorCode => dispatch(redirectKyc(errorCode)),
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(Status);
